import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';

export class PlayersService extends TableService<'players'> {
  constructor(supabase: Supabase) {
    super(supabase, 'players', {
      pk: 'id',
      defaultSort: { field: 'id', ascending: false, nullsFirst: true },
    });
  }

  /**
   * Find multiple players by their IDs
   * @param ids Array of player IDs
   * @returns Promise with array of player records
   */
  public async findMultiple(ids: number[]): Promise<any[]> {
    if (!ids.length) return [];

    const result = await this.table.select('*').in('id', ids);

    if (result.error) throw { status: 500, message: result.error };
    return result.data || [];
  }
}
